import http from '@/api/http';
export function getLicenseMemberPage(params) {
    return http.get(`/licensemember`, { params });
}
export function addLicenseMember(licenseMember) {
    return http.post(`/licensemember`, licenseMember);
}
export function deleteLicenseMember(params) {
    return http.delete(`/licensemember`, { params });
}
